import styled from 'styled-components';
import { useStoreInfosValueContextHook } from '../../../../contexts/StoreInfosContext';
import { useState } from 'react';
import { CustomDialog } from '../../../../../../../components/dialog/v1/CustomDialog';
import _ from 'lodash';
import CustomBlockButton from '../../../../../../../components/button/CustomBlockButton';
import { CustomLabelInput } from '../../../../../../../components/input/CustomLabelInput';
import { useApiInfoContextValueHook } from '../../../../../../../contexts/ApiInfoContext';
import { useFetcher } from '../../../../fetcher/useFetcher';
import { SellertoolSignatureUtils } from '../../../../../../../utils/sellertool-signature-utils';
import { CustomBackdropController } from '../../../../../../../components/backdrop/default/v1';
import { ReturnExchangesApi } from '../../../../../../../apis/ReturnExchangesApi';

const StyledTableCell = styled.td`
  padding: 16px;
  color: #495057;
  border-bottom: 1px solid #dee2e6;

  .info-box{
    display: flex;
    flex-direction: column;
    gap: 3px;
    font-size: 12px;
    font-weight: 600;
  }
`

const StyledModalHeader = styled.div`
    padding: 10px;
`;

const StyledModalBody = styled.div`
    padding: 10px;

    .store-buttons{
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
        gap: 10px;
        .store-button{
            border-radius: 3px;
            color: #333;
            &.selected{
                border: 1px solid #333;
                font-weight: 700;
            }
        }
    }

    .store-memo{
        margin-top: 20px;
    }
    input{
        border:1px solid #e0e0e0;
        border-radius: 3px;
    }
`;

const StyledModalFooter = styled.div`
    padding: 10px;

    button{
        border-radius: 3px;
        background-color: #333;
        color: #fff;
        font-weight: 600;
        border:none;
    }
`;

export function TdSalesChannelInfo({
    returnExchange
}) {
    const storeInfosValueContextHook = useStoreInfosValueContextHook();
    const storeInfos = storeInfosValueContextHook?.storeInfos;

    const storeInfo = storeInfos.find(storeInfo => storeInfo.id === returnExchange?.salesChannelMatchingStoreId);

    const [editModal, setEditModal] = useState(false);

    return (
        <>
            <StyledTableCell>
                <div className='info-box'>
                    <div><span style={{ cursor: 'pointer', textDecoration: 'underline' }} onClick={(e) => { e.stopPropagation(); setEditModal(true); }}>매칭채널: {storeInfo ? <span style={{ fontWeight: '700', color: '#333' }}>{storeInfo?.storeName}</span> : <span style={{ color: '#a0a0a0' }}>미지정</span>}</span></div>
                    <div><span style={{ cursor: 'pointer', textDecoration: 'underline' }} onClick={(e) => { e.stopPropagation(); setEditModal(true); }}>채널메모: {returnExchange?.salesChannelMatchingStoreMemo ? <span style={{ fontWeight: '700', color: '#333' }}>{returnExchange?.salesChannelMatchingStoreMemo}</span> : '-'}</span></div>
                </div>
            </StyledTableCell>

            {editModal &&
                <EditModal
                    open={editModal}
                    onClose={() => setEditModal(false)}
                    returnExchange={returnExchange}
                    storeInfos={storeInfos}
                />
            }
        </>
    );
}

function EditModal({
    open,
    onClose,
    returnExchange,
    storeInfos
}) {
    const apiInfoContextValueHook = useApiInfoContextValueHook();
    const fetcher = useFetcher();
    const [editableReturnExchange, setEditableReturnExchange] = useState(_.cloneDeep(returnExchange));

    const handleChangeSalesChannelMatchingStoreId = (storeInfo) => {
        if (!storeInfo) {
            setEditableReturnExchange(prev => {
                return {
                    ...prev,
                    salesChannelMatchingStoreId: null
                }
            })
        } else {
            setEditableReturnExchange(prev => {
                return {
                    ...prev,
                    salesChannelMatchingStoreId: storeInfo.id
                }
            })
        }
    }

    const handleSubmit = async () => {

        const timestamp = Date.now().toString();
        const signature = SellertoolSignatureUtils().generateSigniture({
            apiKey: apiInfoContextValueHook?.apiInfo?.apiKey,
            secretKey: apiInfoContextValueHook?.apiInfo?.secretKey,
            timestamp: timestamp
        })

        const headers = {
            'x-sellertool-apiKey': apiInfoContextValueHook?.apiInfo?.apiKey,
            'x-sellertool-timestamp': timestamp,
            'x-sellertool-signiture': signature
        }
        CustomBackdropController().showBackdrop();
        const response = await ReturnExchangesApi().updateList({
            headers: headers,
            body: {
                returnExchanges: [editableReturnExchange]
            }
        });

        if (response?.content) {
            await fetcher.fetchReturnExchanges();
            onClose();
        }
        CustomBackdropController().hideBackdrop();
    }

    return (
        <>
            <CustomDialog
                open={open}
                onClose={() => onClose()}
            >
                <StyledModalHeader>
                    <CustomDialog.Header>
                        <CustomDialog.Header.Fake />
                        <CustomDialog.Header.Title>
                            채널정보수정
                        </CustomDialog.Header.Title>
                        <CustomDialog.Header.Close onClick={() => onClose()} />
                    </CustomDialog.Header>
                </StyledModalHeader>
                <form onSubmit={(e) => { e.preventDefault(); handleSubmit() }}>
                    <StyledModalBody>
                        <div className='store-buttons'>
                            <CustomBlockButton
                                type='button'
                                className={`store-button ${!editableReturnExchange?.salesChannelMatchingStoreId ? 'selected' : ''}`}
                                onClick={() => {
                                    handleChangeSalesChannelMatchingStoreId(null);
                                }}
                            >
                                미지정
                            </CustomBlockButton>
                            {storeInfos?.map(storeInfo => {
                                return (
                                    <CustomBlockButton
                                        key={storeInfo.id}
                                        type='button'
                                        className={`store-button ${editableReturnExchange?.salesChannelMatchingStoreId === storeInfo?.id ? 'selected' : ''}`}
                                        onClick={() => {
                                            handleChangeSalesChannelMatchingStoreId(storeInfo);
                                        }}
                                    >
                                        {storeInfo?.storeName}
                                    </CustomBlockButton>
                                );
                            })}
                        </div>
                        <div className='store-memo'>
                            <CustomLabelInput>
                                <CustomLabelInput.Input
                                    type='text'
                                    value={editableReturnExchange?.salesChannelMatchingStoreMemo || ''}
                                    onChange={(e) => {
                                        setEditableReturnExchange(prev => {
                                            return {
                                                ...prev,
                                                salesChannelMatchingStoreMemo: e.target.value
                                            }
                                        })
                                    }}
                                />
                                <CustomLabelInput.Label>채널메모</CustomLabelInput.Label>
                            </CustomLabelInput>
                        </div>
                    </StyledModalBody>
                    <StyledModalFooter>
                        <CustomBlockButton
                            type='submit'
                        >적용</CustomBlockButton>
                    </StyledModalFooter>
                </form>
            </CustomDialog>
        </>
    );
}